// Module
var code = " <div md-colors=\"{'background-color': 'background-100'}\" md-ink-ripple layout=\"row\" layout-align=\"space-between center\"> <span class=\"md-body-2\" ng-transclude></span> <md-icon class=\"fab-icon md-whiteframe-z1\" md-colors=\"{'background-color': 'primary'}\" ng-bind=\"$ctrl.icon\"></md-icon> </div> ";
// Exports
export default code;